
const CATEGORY_ARTICLE_LIST_DATA = {
  CATEGORY_ARTICLE_LIST_DATA_LOAD: "CATEGORY_ARTICLE_LIST_DATA_LOAD",
  CATEGORY_ARTICLE_LIST_DATA_SUCCESS: "CATEGORY_ARTICLE_LIST_DATA_SUCCESS",
  CATEGORY_ARTICLE_LIST_DATA_FAIL: "CATEGORY_ARTICLE_LIST_DATA_FAIL",
};
const CATEGORY_ARTICLE_LIST_API = "tickets/categories/ArticleList";

const ARTICLE_LIST_DATA = {
 GET_ARTICLES_REQUEST : "GET_ARTICLES_REQUEST",
 GET_ARTICLES_SUCCESS : "GET_ARTICLES_SUCCESS",
 GET_ARTICLES_FAILURE : "GET_ARTICLES_FAILURE",
}

const GET_ARTICLE_LIST_DATA_API = 'tickets/article'

 const ARTICLE_DETAILS_DATA = {
  GET_ARTICLE_DETAILS_REQUEST: "GET_ARTICLE_DETAILS_REQUEST",
  GET_ARTICLE_DETAILS_SUCCESS: "GET_ARTICLE_DETAILS_SUCCESS",
  GET_ARTICLE_DETAILS_FAILURE: "GET_ARTICLE_DETAILS_FAILURE",
};

 const GET_ARTICLE_DETAILS_API = "tickets/article"; 

 const ADD_CATEGORY_ARTICLE_DATA = {
  ADD_CATEGORY_ARTICLE_DATA_LOAD: "ADD_CATEGORY_ARTICLE_DATA_LOAD",
  ADD_CATEGORY_ARTICLE_DATA_SUCCESS: "ADD_CATEGORY_ARTICLE_DATA_SUCCESS",
  ADD_CATEGORY_ARTICLE_DATA_FAIL: "ADD_CATEGORY_ARTICLE_DATA_FAIL",
  ADD_CATEGORY_ARTICLE_DATA_RESET: "ADD_CATEGORY_ARTICLE_DATA_RESET",
};
const ADD_CATEGORY_ARTICLE_API = "tickets/article";

const LOAD_CATEGORY_ARTICLE_DATA_DETAIL = {
  LOAD_CATEGORY_ARTICLE_DATA_DETAIL_LOAD: "LOAD_CATEGORY_ARTICLE_DATA_DETAIL_LOAD",
  LOAD_CATEGORY_ARTICLE_DATA_DETAIL_SUCCESS: "LOAD_CATEGORY_ARTICLE_DATA_DETAIL_SUCCESS",
  LOAD_CATEGORY_ARTICLE_DATA_DETAIL_FAIL: "LOAD_CATEGORY_ARTICLE_DATA_DETAIL_FAIL",
};
const LOAD_CATEGORY_ARTICLE_DATA_DETAIL_API = "tickets/article/";

 const UPDATE_CATEGORY_ARTICLE_DATA = {
  UPDATE_CATEGORY_ARTICLE_DATA_LOAD: "UPDATE_CATEGORY_ARTICLE_DATA_LOAD",
  UPDATE_CATEGORY_ARTICLE_DATA_SUCCESS: "UPDATE_CATEGORY_ARTICLE_DATA_SUCCESS",
  UPDATE_CATEGORY_ARTICLE_DATA_FAIL: "UPDATE_CATEGORY_ARTICLE_DATA_FAIL",
  UPDATE_CATEGORY_ARTICLE_DATA_RESET: "UPDATE_CATEGORY_ARTICLE_DATA_RESET"
};
const UPDATE_CATEGORY_ARTICLE_API = "tickets/article/";

const ADD_CATEGORY_ARTICLE_S3_DATA = {
  ADD_CATEGORY_ARTICLE_S3_DATA_LOAD: "ADD_CATEGORY_ARTICLE_S3_DATA_LOAD",
  ADD_CATEGORY_ARTICLE_S3_DATA_SUCCESS: "ADD_CATEGORY_ARTICLE_S3_DATA_SUCCESS",
  ADD_CATEGORY_ARTICLE_S3_DATA_FAIL: "ADD_CATEGORY_ARTICLE_S3_DATA_FAIL",
  ADD_CATEGORY_ARTICLE_S3_DATA_RESET: "ADD_CATEGORY_ARTICLE_S3_DATA_RESET",
};
const ADD_CATEGORY_ARTICLE_S3_API = "tickets/article/uploadtos3";

export {
  ARTICLE_LIST_DATA,
  ARTICLE_DETAILS_DATA,
  GET_ARTICLE_LIST_DATA_API,
  GET_ARTICLE_DETAILS_API,
  ADD_CATEGORY_ARTICLE_DATA,
  ADD_CATEGORY_ARTICLE_API,
  LOAD_CATEGORY_ARTICLE_DATA_DETAIL,
  LOAD_CATEGORY_ARTICLE_DATA_DETAIL_API,
  UPDATE_CATEGORY_ARTICLE_DATA,
  UPDATE_CATEGORY_ARTICLE_API,
  ADD_CATEGORY_ARTICLE_S3_DATA,
  ADD_CATEGORY_ARTICLE_S3_API,
  CATEGORY_ARTICLE_LIST_API,
  CATEGORY_ARTICLE_LIST_DATA,
}